import React from 'react';
import PropTypes from 'prop-types';
import { RichText } from 'prismic-reactjs';
import ReactHtmlParser from 'react-html-parser';

import {
  Wrapper,
  StyledContainer,
  Columns,
  Card,
  Testimonial,
  Author,
  AuthorRelation,
} from './styles';

// * title {richText} the section heading for the component
// * items {array} of testimonial objs from the CMS

const AdminTestimonials = ({ data }) => {
  if (!data) return null;

  const {
    titleHtml,
    items,
    colourOverrideBackground,
    colourOverrideText,
    colourOverrideCardBG,
  } = data;

  const textColor = colourOverrideText
    ? `text-${colourOverrideText.toLowerCase()}`
    : 'text-Light';

  const type = items.some(item => item.image.url) ? 'with-image' : '';
  return (
    <Wrapper
      id="Admin-Testimonials"
      className={[type, textColor]}
      colourOverrideBackground={colourOverrideBackground}
    >
      <StyledContainer className="auto-margin">
        {ReactHtmlParser(titleHtml)}
        {/* Controls the margin between the divs */}
        <Columns spacing="15px">
          {items.map(({ text, giver, imageSharp, status }, index) => {
            return (
              <Card
                key={`testimonial-${RichText.asText(
                  giver
                )}-${index.toString()}`}
                image={imageSharp.publicURL || null}
                colourOverrideCardBG={colourOverrideCardBG}
              >
                <Testimonial>&quot;{RichText.asText(text)}&quot;</Testimonial>
                <Author>{RichText.asText(giver)}</Author>
                <AuthorRelation>{RichText.asText(status)}</AuthorRelation>
              </Card>
            );
          })}
        </Columns>
      </StyledContainer>
    </Wrapper>
  );
};

AdminTestimonials.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default AdminTestimonials;
